import {
  CheckThirdJumpRequest,
  CodeV3Request,
  GeneralBindInfoRequest,
  GeneralLoginResponse,
  GeneralLoginV2Request,
  GeneralLoginV2Response,
  MailCodeLoginRequest,
  PhoneCodeV2Request,
  PhoneCodeV2Response,
  PhoneSmsLoginRequest,
  RefreshTokenRequest,
  RefreshTokenResponse,
  ResetPwdRequest,
  SignUpRequest,
  UserInfo,
  MailCodeBindRequest,
  UserInfoUpdateRequest,
  QRCodeResponse
} from "@pinnacle/types/user";
import { del, get, post } from "./request";

export const generalLoginV2 = async (data: GeneralLoginV2Request) =>
  post<GeneralLoginV2Response>("/user/v2/login/general", data);

export const smsLogin = async (data: PhoneSmsLoginRequest) =>
  post<GeneralLoginResponse>("/user/v2/login/sms", data);

export const mailLogin = async (data: MailCodeLoginRequest) =>
  post<GeneralLoginResponse>("/user/v2/login/mail", data);

export const mailBind = async (data: MailCodeBindRequest) =>
  post("/user/v2/bind/mail", data);

export const refreshToken = async (data: RefreshTokenRequest) =>
  post<RefreshTokenResponse>("/user/v1/refresh", data);

export const personInfo = () => get<UserInfo>("/grpc/user/v1/me");

export const updatePersonInfo = async (data: UserInfoUpdateRequest) =>
  post("/grpc/user/v1/me", data);

export const thirdLoginUrl = async (
  platform: string,
  from: string,
  callback: string
) =>
  get<{ url: string }>("/user/v1/third/jump", {
    platform,
    from,
    callback,
  });

export const thirdLoginCallback = async (data: CheckThirdJumpRequest) =>
  post<GeneralLoginResponse>("/user/v1/third/callback", data);

export const thirdBindCallback = async (data: CheckThirdJumpRequest) =>
  post<null>("/user/v2/bind/callback", data);

export const phoneCode = async (data: PhoneCodeV2Request) =>
  post<PhoneCodeV2Response>("/base/v2/code", data);

export const codeV3 = async (data: CodeV3Request) =>
  post<PhoneCodeV2Response>("/base/v3/code", data);

export const signUpByPhone = async (data: SignUpRequest) =>
  post<null>("/user/v1/register/general", data);

export const resetPwdByPhone = async (data: ResetPwdRequest) =>
  post<null>("/user/v1/reset/general", data);

export const deleteAccount = async () => del<null>("/user/v2", {});

export const phoneMailBind = async (data: GeneralBindInfoRequest) =>
  post<null>("/user/v2/bind", data);

export const deleteBind = async (platform: string) =>
  del<null>("/user/v2/unbind/third", {
    platform,
  });

export const qrCodeStatus = async (code: string) =>
  get<{ status: string }>("/user/v2/login/QRCode", {
    code,
  });

export const authQRCode = async (code: string) =>
  post("/user/v2/authorization", { code });

export const qrCodeLogin = async (id: string) =>
  post<QRCodeResponse>(
    '/base/v3/QRCode?endpoint=https://app.pinnacle.run/authorization',
    { id },
  );
export const platformQRCodeStatus = async (id: string) =>
  get<GeneralLoginResponse>(
    `/user/v2/login/QRCode?id=${id}&code=`,
  );
